import React from 'react'
import './css/Team.css'

const OurTeam = () => {
    return (
        <>
            <section id="team" className="team-area">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="site-heading text-center mt-5">
                                <h2>
                                    Our <span>Team</span>
                                </h2>
                                <h4><b>Meet our awesome and expert team members</b></h4>
                            </div>
                        </div>
                    </div>
                    <div className="row team-items">
                        <div className="col-md-3 single-item">
                            <div className="item">
                                <div className="thumb">
                                    <img
                                        className="img-fluid"
                                        src="https://i.ibb.co/JC4skS0/team-animate.jpg"
                                        alt="Thumb"
                                    />
                                    <div className="overlay">
                                        <div className="social">
                                            <ul>
                                                <li className="twitter">
                                                    <a href="/">
                                                        <i className="fab fa-twitter" />
                                                    </a>
                                                </li>
                                                <li className="pinterest">
                                                    <a href="/">
                                                        <i className="fab fa-pinterest" />
                                                    </a>
                                                </li>
                                                <li className="instagram">
                                                    <a href="/">
                                                        <i className="fab fa-instagram" />
                                                    </a>
                                                </li>
                                                <li className="vimeo">
                                                    <a href="/">
                                                        <i className="fab fa-vimeo-v" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="info">
                                    <span className="message">
                                        <a href="/">
                                            <svg
                                                stroke="currentColor"
                                                fill="currentColor"
                                                strokeWidth={0}
                                                viewBox="0 0 512 512"
                                                className="icon"
                                                height="1em"
                                                width="1em"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z" />
                                            </svg>
                                        </a>
                                    </span>
                                    <h5><a href='mailto:imman@boscosofttech.com'>imman@boscosofttech.com</a></h5>
                                    <h6><a href='tel:9786000436'>9786000436</a></h6>
                                    <span>Product Manager</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 single-item">
                            <div className="item">
                                <div className="thumb">
                                    <img
                                        className="img-fluid"
                                        src="https://i.ibb.co/JC4skS0/team-animate.jpg"
                                        alt="Thumb"
                                    />
                                    <div className="overlay">
                                        <div className="social">
                                            <ul>
                                                <li className="twitter">
                                                    <a href="/">
                                                        <i className="fab fa-twitter" />
                                                    </a>
                                                </li>
                                                <li className="pinterest">
                                                    <a href="/">
                                                        <i className="fab fa-pinterest" />
                                                    </a>
                                                </li>
                                                <li className="instagram">
                                                    <a href="/">
                                                        <i className="fab fa-instagram" />
                                                    </a>
                                                </li>
                                                <li className="vimeo">
                                                    <a href="/">
                                                        <i className="fab fa-vimeo-v" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="info">
                                    <span className="message">
                                        <a href="/">
                                            <svg
                                                stroke="currentColor"
                                                fill="currentColor"
                                                strokeWidth={0}
                                                viewBox="0 0 512 512"
                                                className="icon"
                                                height="1em"
                                                width="1em"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z" />
                                            </svg>
                                        </a>
                                    </span>
                                    <h5><a href='mailto:alwinj@boscosofttech.com'>alwinj@boscosofttech.com</a></h5>
                                    <h6><a href='tel:7395848924'>7395848924</a></h6>
                                    <span>Sales Team</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 single-item">
                            <div className="item">
                                <div className="thumb">
                                    <img
                                        className="img-fluid"
                                        src="https://i.ibb.co/JC4skS0/team-animate.jpg"
                                        alt="Thumb"
                                    />
                                    <div className="overlay">
                                        <div className="social">
                                            <ul>
                                                <li className="twitter">
                                                    <a href="/">
                                                        <i className="fab fa-twitter" />
                                                    </a>
                                                </li>
                                                <li className="pinterest">
                                                    <a href="/">
                                                        <i className="fab fa-pinterest" />
                                                    </a>
                                                </li>
                                                <li className="instagram">
                                                    <a href="/">
                                                        <i className="fab fa-instagram" />
                                                    </a>
                                                </li>
                                                <li className="vimeo">
                                                    <a href="/">
                                                        <i className="fab fa-vimeo-v" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="info">
                                    <span className="message">
                                        <a href="/">
                                            <svg
                                                stroke="currentColor"
                                                fill="currentColor"
                                                strokeWidth={0}
                                                viewBox="0 0 512 512"
                                                className="icon"
                                                height="1em"
                                                width="1em"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z" />
                                            </svg>
                                        </a>
                                    </span>
                                    <h5><a href='mailto:cristo@boscosofttech.com'>cristo@boscosofttech.com</a></h5>
                                    <h6><a href='tel:9786000436'>9786000436</a></h6>
                                    <span>Support Team</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 single-item">
                            <div className="item">
                                <div className="thumb">
                                    <img
                                        className="img-fluid"
                                        src="https://i.ibb.co/JC4skS0/team-animate.jpg"
                                        alt="Thumb"
                                    />
                                    <div className="overlay">
                                        <div className="social">
                                            <ul>
                                                <li className="twitter">
                                                    <a href="/">
                                                        <i className="fab fa-twitter" />
                                                    </a>
                                                </li>
                                                <li className="pinterest">
                                                    <a href="/">
                                                        <i className="fab fa-pinterest" />
                                                    </a>
                                                </li>
                                                <li className="instagram">
                                                    <a href="/">
                                                        <i className="fab fa-instagram" />
                                                    </a>
                                                </li>
                                                <li className="vimeo">
                                                    <a href="/">
                                                        <i className="fab fa-vimeo-v" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="info">
                                    <span className="message">
                                        <a href="/">
                                            <svg
                                                stroke="currentColor"
                                                fill="currentColor"
                                                strokeWidth={0}
                                                viewBox="0 0 512 512"
                                                className="icon"
                                                height="1em"
                                                width="1em"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z" />
                                            </svg>
                                        </a>
                                    </span>
                                    <h5><a href='mailto:alwinj@boscosofttech.com'>alwinj@boscosofttech.com</a></h5>
                                    <h6><a href='tel:7395848924'>7395848924</a></h6>
                                    <span>Sales Team</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </>

    )
}

export default OurTeam
